import {DataTable, FormDialog} from '@management-ui/core';
import {Alert, Snackbar} from '@mui/material';
import {makeStyles} from '@mui/styles';
import * as React from 'react';
import {useCallback, useContext, useMemo, useRef, useState} from 'react';
import {ServiceContext} from '../../../../components/Services';
import YesNo from '../../../../components/YesNo';
import AccessKeyForm from '../../forms/AccessKeyForm';

const useStyles = makeStyles(theme => ({
  key: {
    fontFamily: theme.typography.fixedWidth
  }
}));

const AccessKeys = () => {
  const classes = useStyles();
  const services = useContext(ServiceContext);

  /** @type {({current: DataTable})} */
  const tableRef = useRef();
  const [selected, setSelected] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const [createdOpen, setCreatedOpen] = useState(false);
  const [createdKey, setCreatedKey] = useState({});

  const handleSelect = useCallback(template => {
    setSelected(template);
    setShowForm(true);
  }, [])

  const handleSaved = useCallback((saved, refresh) => {
    tableRef.current?.refresh();
    setShowForm(false);
    if (!selected) {
      setCreatedKey(saved)
      setCreatedOpen(true)
      refresh()
    }
  }, [selected]);

  return (
    <>
      <DataTable
        ref={tableRef}
        title="Access Keys"
        actions={{
          after: [
            {
              icon: 'add',
              tooltip: 'Add New Key',
              isFreeAction: true,
              onClick: () => handleSelect(null)
            }
          ]
        }}
        columns={useMemo(() => [
          {title: 'Title', field: 'title'},
          {title: 'Public', field: 'public'},
          {title: 'Active?', field: 'is_active', render: data => <YesNo value={data.is_active}/>},
        ], [])}
        loadData={query => new Promise((resolve, reject) => {
          services.accessKey.getTableKeys(query)
            .then(response => {
              resolve({
                data: response.data, page: response.meta.current_page - 1, totalCount: response.meta.total
              });
            }).catch(() => {
            reject();
          });
        })}
        onRowClick={handleSelect}
      />
      <FormDialog
        title={selected ? 'Edit Key' : 'Add New Key'}
        open={showForm}
        maxWidth="md"
        onClose={() => setShowForm(false)}
        render={(props) => <AccessKeyForm
          {...props}
          keyPair={selected ?? {}}
          onSaved={handleSaved}
        />}
      />
      <Snackbar open={createdOpen} onClose={() => setCreatedOpen(false)}>
        <Alert onClose={() => setCreatedOpen(false)} severity="success">
          Your new key has been created, please be sure to copy your private key as it will not be displayed again:
          <br/>
          <p className={classes.key}>
            <strong>Title:</strong>&nbsp;&nbsp;&nbsp;&nbsp;{createdKey.title}<br/>
            <strong>Public:</strong>&nbsp;&nbsp;&nbsp;{createdKey.public}<br/>
            <strong>Private:</strong>&nbsp;&nbsp;{createdKey.private}
          </p>
        </Alert>
      </Snackbar>
    </>
  );
}

export default AccessKeys;
